/**
 * @Author: ikoros
 * @Date:   2020-04-06T17:07:05+08:00
 * @Last modified by:   ikoros
 * @Last modified time: 2020-04-06T17:07:24+08:00
 */
 import React from 'react';

 export default React.createContext();
